// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"279d3def","396":"ea0b7642"}[chunkId] + ".chunk.js";
};